import {
  SET_LAST_UPDATE_TIME,
  SET_USER_INFO,
  SET_MENU_STATUS,
  SET_DEVICE_SIZE,
  SET_LANGUAGE,
  SET_LANGUAGE_OBJ,
  SET_DEVICE_INFO,
  SET_RF_PATH
} from '../actionTypes/commonTypes'
export const setMenuStatus = payload => {
  return {
    type: SET_MENU_STATUS,
    payload
  }
}
export const setUserInfo = payload => {
  return {
    type: SET_USER_INFO,
    payload
  }
}
export const setLastUpdateTime = payload => {
  return {
    type: SET_LAST_UPDATE_TIME,
    payload
  }
}
export const setDeviceSize = payload => {
  return {
    type: SET_DEVICE_SIZE,
    payload
  }
}
export const setLanguage = payload => {
  return {
    type: SET_LANGUAGE,
    payload
  }
}
export const setLanguageObj = payload => {
  return {
    type: SET_LANGUAGE_OBJ,
    payload
  }
}
export const setDeviceInfo = payload => {
  return {
    type: SET_DEVICE_INFO,
    payload
  }
}
export const setRfPath = payload => {
  return {
    type: SET_RF_PATH,
    payload
  }
}
